import {
  faUser,
  faCalendarLines,
  faUsers,
  faHeart,
} from '@fortawesome/pro-light-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import type { LevelTwoConfigKey } from '@/feature-flags/types/variant.types';

export type LevelTwoFeatureKey = 'newProfile' | 'newAppointments' | 'newDependents' | 'newFavorites';

export interface LevelTwoFeatureMetadata {
  configKey: LevelTwoConfigKey;
  label: string;
  icon: IconDefinition;
  testId: (typeof DataTestIdEnum)[keyof typeof DataTestIdEnum];
  paths: string[];
  internalRoute: string;
}

export const LEVEL_TWO_FEATURES: Record<LevelTwoFeatureKey, LevelTwoFeatureMetadata> = {
  newProfile: {
    configKey: 'newProfile',
    label: 'Perfil',
    icon: faUser,
    testId: DataTestIdEnum.ITEM_PROFILE,
    paths: ['/meu-perfil'],
    internalRoute: '/meu-perfil',
  },
  newAppointments: {
    configKey: 'newAppointments',
    label: 'Agendamentos',
    icon: faCalendarLines,
    testId: DataTestIdEnum.ITEM_APPOINTMENTS,
    paths: [
      '/agendamentos',
      '/agendamentos/:id',
      '/agendamentos/:id/solicitar-cancelamento',
      '/agendamentos/:id/avaliar',
    ],
    internalRoute: '/agendamentos',
  },
  newDependents: {
    configKey: 'newDependents',
    label: 'Dependentes',
    icon: faUsers,
    testId: DataTestIdEnum.ITEM_DEPENDENTS,
    paths: ['/dependentes', '/dependentes/novo', '/dependentes/:id'],
    internalRoute: '/dependentes',
  },
  newFavorites: {
    configKey: 'newFavorites',
    label: 'Favoritos',
    icon: faHeart,
    testId: DataTestIdEnum.ITEM_FAVORITES,
    paths: ['/favoritos'],
    internalRoute: '/favoritos',
  },
} as const;
